import SelectFilter from "@components/common/SelectFilter.jsx";
import useFilterData from "@hooks/useFilterData.js";

function BusinessUnitsFilter({
	value,
	onChange,
	params = {},
	enabled = true,
	disabled = false,
	label = "Filter by",
	placeholder = "Business Unit",
}) {
	const { data, isLoading, hasMore, searchTerm, setSearchTerm } = useFilterData({
		endpoint: "/api/business-units",
		isPaginated: false,
		enabled,
		queryParams: {
			...params,
		},
	});

	return (
		<SelectFilter
			id="business_unit-filter"
			dataTestId="business_unit-filter"
			label={label}
			placeholder={placeholder}
			value={value}
			onChange={onChange}
			options={data}
			isLoading={isLoading}
			hasMore={hasMore}
			searchTerm={searchTerm}
			onSearchChange={setSearchTerm}
			optionLabel="name"
			optionValue="id"
			disabled={disabled}
			isPaginated={false}
			searchPlaceholder="Search by business unit"
		/>
	);
}
export default BusinessUnitsFilter;
